module.exports = __webpack_public_path__ + "static/img/tab1.65b71d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth/tab1.svg
// module id = SKOe
// module chunks = 0